import { Locale } from "utils/dateFormat";
import { PendingContact } from "types/PendingContact";
import { Provider } from "types/Provider";
import { BoardMember } from "types/BoardMember";
import { Resident } from "types/Resident";
import { Worker } from "types/Worker";

export function emptyUnitListSubtitle(locale: Locale): string {
  return locale === "es" ? "Sin residente" : "No resident";
}

export function residentListSubtitle(
  resident: Resident,
  locale: Locale
): string {
  const typeLabel =
    resident.type === "owner"
      ? locale === "es"
        ? "Propietario"
        : "Owner"
      : resident.type === "tenant"
        ? locale === "es"
          ? "Inquilino"
          : "Tenant"
        : locale === "es"
          ? "Propietario No Residente"
          : "Non-resident owner";

  let subtitle = typeLabel;
  if (resident.unitName) {
    subtitle += ` • ${resident.unitName}`;
  }
  if (!(resident.isActive ?? true)) {
    subtitle += ` • ${locale === "es" ? "Inactivo" : "Inactive"}`;
  }
  return subtitle;
}

export function boardMemberListSubtitle(
  member: BoardMember,
  locale: Locale
): string {
  const parts = [
    member.role?.trim() ||
      (locale === "es" ? "Miembro de la comisión" : "Board member"),
  ];
  if (!(member.isActive ?? true)) {
    parts.push(locale === "es" ? "Inactivo" : "Inactive");
  }
  return parts.join(" • ");
}

export function workerListSubtitle(worker: Worker, locale: Locale): string {
  const role =
    worker.role?.trim() ||
    (locale === "es" ? "Sin rol" : "No role");
  const parts = [role];
  if (worker.condoName?.trim()) {
    parts.push(worker.condoName.trim());
  }
  if (!(worker.isActive ?? true)) {
    parts.push(locale === "es" ? "Inactivo" : "Inactive");
  }
  return parts.join(" • ");
}

export function providerListSubtitle(provider: Provider): string {
  const parts = [
    provider.contact.name.trim(),
    provider.serviceType.trim(),
  ].filter(Boolean);
  return parts.join(" • ");
}

export function pendingContactListSubtitle(pending: PendingContact): string {
  return pending.identificationDetails?.trim() ?? "";
}

export function otherContactListSubtitle(locale: Locale): string {
  return locale === "es" ? "Contacto general" : "General contact";
}
